export class CapacityBelowBookedError extends Error {
  code?: string = 'class/capacity-below-booked';
}
